<template>
  <div class="e-faq e-scroll-container">
    <VuePerfectScrollbar class="e-faq__inner e-content__inner">
      <div class="e-content__scroll">
        <div class="e-module e-module--limited e-module--left">
          <Loading v-if="loading" />
          <template v-else>
            <header class="e-module__head">
              <h1>{{ $t('system.navigation.support') }}</h1>
            </header>
            <div class="e-faq__item-container">
              <div v-for="group in Object.keys(groupedItems)" :key="group + 'container'">
                <h2>{{ group }}</h2>
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    v-for="(item, index) in groupedItems[group]"
                    :key="group + index"
                    class="e-faq__collapse-item"
                    :name="group + index"
                  >
                  <template slot="title">
                    <h4 class="el-collapse-item__title">
                      {{ item.question | noCategory }}
                    </h4>
                  </template>
                  <div v-html="item.answer" />
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </template>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Loading from 'atoms/Loading/Loading'

const getContent = value =>
  value && value.indexOf(':') > -1
    ? value.substring(value.indexOf(':') + 2, value.length)
    : value
const getCategory = value =>
  value && value.indexOf(':') > -1
    ? value.substring(0, value.indexOf(':'))
    : value

export default {
  name: 'FaqWrapper',
  filters: {
    noCategory(value) {
      return getContent(value)
    },
    category(value) {
      return getCategory(value)
    }
  },
  components: {
    Loading,
    VuePerfectScrollbar
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    groupedItems() {
      const groups = {}
      this.items.forEach(item => {
        const category = getCategory(item.question)
        if (!category) {
          return
        }
        if (!(category in groups)) {
          groups[category] = []
        }
        groups[category].push(item)
      })
      return groups
    }
  },
  data: () => ({
    activeNames: []
  })
}
</script>

<style lang="scss">
@import '_assets/faq';
</style>
<style lang="scss" scoped>
.e-faq__inner {
  ::v-deep .el-collapse-item__header {
    display: block;
  }
}
</style>
